export const STORAGE_KEYS = {
    
    usuarioLogado: "Usuario Logado",
    token: "token",
    validadeToken: 'vld_t',
    sessionID: "si",
    ultimaPaginaVisitada: "lvp",
    horaUltimaVisita: "tlvp",
    coordsVisitante: "vico"
}